export default __webpack_public_path__ + "static/key_w.325270808300cdaa86952c477d1ac8bd.svg";